import { LANGUAGE } from './constants/constants';
import FRENCH from './locales/fr/global.json';

export const resources = { [LANGUAGE]: { translation: FRENCH } };
